// import { createReduxHistoryContext } from "redux-first-history";
import { combineReducers } from "redux";
// import { createBrowserHistory } from "history";
import {
  localStore,
  addressbook,
  directGroups,
  appointments,
  plans
  // session,
} from "../reducers";
import { session } from "../reducers/sessionManagement";

// export const history = createBrowserHistory();
// const { routerReducer } = createReduxHistoryContext({
//   history: createBrowserHistory(),
// }); // import {types as sessionTypes} from "reducers/session";

const appReducer = combineReducers({
  session,
  // router: routerReducer,
  localStore,
  addressbook,
  directGroups,
  appointments,
  plans,
});

const rootReducers = (state, action) => {
  // if (action.type === sessionTypes.LOG_OUT) {
  //   return {};
  // }
  return appReducer(state, action);
};
export default rootReducers;
